import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    // A new page starts at the top at once; the site-wide smooth scrolling is for in-page links.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    const main = document.getElementById("main-content");
    if (main instanceof HTMLElement) main.focus({ preventScroll: true });
  }, [location.pathname]);

  return null;
}
